import React, {Fragment, useRef, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import Loading from "../Loading/Loading";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";


export default function RestaurantReport(){
    let state=useSelector((state)=> state);
    const ref=useRef();

    const [DivisionVisit, setDivisionVist]=useState([]);
    const [CircleVisit, setCircleVisit]=useState([]);
    const [DataRestaurant, setDataRestaurant]=useState([]);
    const [ColumnRestaurant, setColumnRestaurant]=useState([{}]);

    const [DataRestaurantRevenue, setDataRestaurantRevenue]=useState([]);
    const [ColumnRestaurantRevenue, setColumnRestaurantRevenue]=useState([{}]);
    const [DataLength, setDatalength]=useState(0);

    const[DataStatus, setDataStatus]=useState(false);
    const[BIN, setBIN]=useState();
    const[NameResturant, setNameResturant]=useState();





    const [Show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow= () => setShow(true);

    const [ShowRestaurant, setShowRestaurant] = useState(false);
    const handleCloseRestaurant = () => setShowRestaurant(false);
    const handleShowRestaurant= () => setShowRestaurant(true);
    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setBIN(row['BIN']);
            setNameResturant(row['Name']);
                handleShow();
        }
    }

    const getVisitMap=()=>{
        setDataStatus(true);
        setDatalength(0)

        const Commi=document.getElementById("cmbCommiVisit");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const DivisionVisit=document.getElementById("cmbDivisionVisit");
        const DivisionValueVisit=DivisionVisit.options[DivisionVisit.selectedIndex].text;

        const CircleVisit=document.getElementById("cmbCircleVisit");
        const CircleValueVisit=CircleVisit.options[CircleVisit.selectedIndex].text;

        const Category=document.getElementById("cmbCategory");
        const CategoryValue=Category.options[Category.selectedIndex].text;

        const SearchBin=document.getElementById("txtBin").value;
        const SearchName=document.getElementById("txtName").value;

        const DataLimitVisit=document.getElementById("cmbDataLimitVisit");
        const DataLimitValueVisit=DataLimitVisit.options[DataLimitVisit.selectedIndex].text;

        let getCommiVisit=" ";
        let getDivisionVisit=" ";
        let getCircleVisit=" ";
        let getBin="" ;
        let getName="" ;


        let getlimitVisit ="";

        let jsonObject;



        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommiVisit="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommiVisit="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(DivisionVisit.selectedIndex!=0){getDivisionVisit="And Division Like '%"+DivisionValueVisit+"%'"}}
        else{getDivisionVisit="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(CircleVisit.selectedIndex!=0){getCircleVisit="And Circle = '"+CircleValueVisit+"'"}}
        else {getCircleVisit="And Circle = '"+state.accessCir+"'"}

        if(SearchBin!=""){ getBin=" And BIN Like '%"+SearchBin+"%'"}
        if(SearchName!=""){ getName=" And Name Like '%"+SearchName+"%'"}

        if(DataLimitVisit.selectedIndex !=0){getlimitVisit=" LIMIT " +DataLimitValueVisit

            jsonObject={"sql":"Select Name,BIN,Circle,ARO,ARO_Mobile from BIN where Category='"+CategoryValue+"' "+getCommiVisit+" "+getDivisionVisit+" "+getCircleVisit+" "+getBin+" "+getName+"  "+getlimitVisit+" "}



        }else{getlimitVisit=""

            jsonObject={"sql":" Select count(BIN)AS 'Total BIN' from BIN where Category='"+CategoryValue+"' "+getCommiVisit+" "+getDivisionVisit+" "+getCircleVisit+" "+getBin+" "+getName+"  "}



        }

        setColumnRestaurant([{}]);setDataRestaurant([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {
                await setColumnRestaurant(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataRestaurant(result);
                setDataStatus(false)
            }
        }).catch(error=>{ setDataStatus(false);});
    }
    const getRestaurantRevenue=(status)=>{


        let jsonObject="";
        if(status==1){ jsonObject  ={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25," +
                "January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26 from revenue_25_26_view where BIN='"+BIN+"' "};}
        else if(status==2){ jsonObject  ={"sql":" SELECT FY, Month, Total_Sales_Value,Net_Payable_VAT,Deposited_VAT,Closing_Balance_VAT,Online_Return from revenue_analyse_view where BIN='"+BIN+"' order by month_code desc"};}





        setColumnRestaurantRevenue([{}]);setDataRestaurantRevenue([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnRestaurantRevenue(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataRestaurantRevenue(result);

                handleShowRestaurant();

            }
        }).catch(error=>{});

    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCommiVisit"
                                            onChange={()=>{
                                                setDivisionVist([]);
                                                setCircleVisit([]);
                                                const e = document.getElementById("cmbCommiVisit");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionVist(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDivisionVisit"
                                            onChange={()=>{
                                                setCircleVisit([])
                                                const e = document.getElementById("cmbDivisionVisit");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleVisit(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            DivisionVisit.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCircleVisit" >
                                        <option >All Circle</option>

                                        {
                                            CircleVisit.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCategory" >
                                        <option >Restaurant</option>
                                        <option >Sweets</option>
                                        <option >Hotel</option>
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtName"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitVisit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getVisitMap}>Search</button>
                                </Col>


                            </Row>

                        </div>
                    </Col>

                    <Col lg={9}>

                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                                DataStatus? <LoadingText/>
                                    :<BootstrapTable ref={ref} selectRow={selectRow} id="BinTable" keyField='BIN' data={DataRestaurant} columns={ColumnRestaurant}></BootstrapTable>


                            }
                        </div>
                        <di>
                            <label className="text-danger">Data found: {DataLength}</label>

                        </di>

                    </Col>


                </Row>


            </div>

            <Modal show={ShowRestaurant} onHide={handleCloseRestaurant} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{NameResturant}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataRestaurantRevenue} columns={ColumnRestaurantRevenue}></BootstrapTable>}

                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseRestaurant}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
            <Modal show={Show} onHide={handleClose}>
                <Modal.Header closeButton>

                    <label>{NameResturant}</label>

                </Modal.Header>
                <Modal.Body >
                    <div >
                        <div>
                            <Button onClick={()=>getRestaurantRevenue(1)}>Monthly Revenue</Button>
                        </div><hr/>
                        <div>
                            <Button  onClick={()=>getRestaurantRevenue(2)}>IVAS Revenue</Button>
                        </div>


                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
        </Fragment>

    )
}
